import { databaseViewFilterFunctions } from '@streamlain/database-identity';
import { format } from 'date-fns/format';

import { localDateOfDay } from '../../../property-presets/date/calendar-day.js';
import { t } from '../../logical/type-presets.js';
import { createFilter } from './create.js';

const DAY_MS = 86_400_000;

export const dateFilter = [
  createFilter({
    name: 'olderThanDays',
    self: t.date.instance(),
    args: [t.number.instance()] as const,
    label: 'Older than days',
    shortString: value => (value ? ` > ${value.value} days old` : undefined),
    impl: databaseViewFilterFunctions.olderThanDays,
  }),
  createFilter({
    name: 'before',
    self: t.date.instance(),
    args: [t.date.instance()] as const,
    label: 'Before',
    shortString: v =>
      v ? ` < ${format(localDateOfDay(v.value), 'yyyy/MM/dd')}` : undefined,
    impl: databaseViewFilterFunctions.before,
    // The filter date is a day; a new row takes the day before it.
    defaultValue: args => args[0] - DAY_MS,
  }),
  createFilter({
    name: 'after',
    self: t.date.instance(),
    args: [t.date.instance()] as const,
    label: 'After',
    shortString: v =>
      v ? ` > ${format(localDateOfDay(v.value), 'yyyy/MM/dd')}` : undefined,
    impl: databaseViewFilterFunctions.after,
    defaultValue: args => args[0] + DAY_MS,
  }),
];
